<template>
    <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" x="0" y="0" viewBox="0 0 44.9 44.9"
        style="enable-background:new 0 0 44.9 44.9" xml:space="preserve">

        <g id="icon-close" transform="translate(-290.256 -1295.257)">
            <path id="Path_1518" vector-effect="non-scaling-stroke" class="st0" d="m291 1296 21.8 21.8-21.8 21.8" />
            <path id="Path_1519" vector-effect="non-scaling-stroke" class="st0" d="m334.5 1296-21.8 21.8 21.8 21.8" />
        </g>
    </svg>
</template>

<script>
export default {

}
</script>

<style scoped>
.st0 {
    fill: none;
    stroke: #fff;
    stroke-width: 1.75
}
</style>